import moment from "moment";

export const ISO_DATE_TIME = 'YYYY-MM-DDTHH:mm:ss';
export const ISO_DATE = 'YYYY-MM-DD';

export const format = (date, format = null) => {
	return date ? moment(date).format(format || moment.localeData().longDateFormat('L')) : '';
};

export const formatDate = (date) => {
	return format(date);
};

export const formatDateTime = (date) => {
	return format(date, 'DD.MM.YYYY HH:mm:ss');
};

export const formatDateOrYear = (date, f = null) => {
	if (!date) {
		return null;
	}
	if (("" + date).length === 4) {
		return 1 * date;
	}
	return format(date, f);
};

export const today = () => {
	return new Date()
};

export const getAge = (date) => {
	if (!date) {
		return null
	}
	return moment(today()).diff(moment(date), "years")
};

export const getDelta = (a, b, unit = "days") => {
	if (!a || !b) {
		return null
	}
	return moment(a).diff(moment(b), unit)
};



// WEBPACK FOOTER //
// ./src/utils/date.js